import {
  CommunicationDisplayConditionsDto,
  EnrollmentStatus,
} from '@zorro/clients';

export function hasSpecialEnrollmentCommunication(
  communicationConditions?: CommunicationDisplayConditionsDto
): boolean {
  if (!communicationConditions) return false;

  return (
    communicationConditions.isAor ||
    communicationConditions.isSelfEnrollAndStatusElectionSubmitted ||
    communicationConditions.isInitialPayments ||
    communicationConditions.isAutoPay ||
    communicationConditions.isCarrierApplicationElectionSubmitted ||
    communicationConditions.isCarrierApplicationRequestSent
  );
}

export function isEnrollmentStatusInActivePhase(
  status: EnrollmentStatus
): boolean {
  const allowedStatuses = new Set<EnrollmentStatus>([
    EnrollmentStatus.PENDING_ELECTION_WINDOW,
    EnrollmentStatus.ELECTION_ACTIVE,
    EnrollmentStatus.ELECTION_ACTIVE_HAS_NOT_STARTED,
    EnrollmentStatus.ELECTION_ACTIVE_STARTED,
    EnrollmentStatus.ELECTION_SUBMITTED,
    EnrollmentStatus.ENROLLMENT_IN_PROCESS,
    EnrollmentStatus.ENROLLMENT_CONFIRMED,
    EnrollmentStatus.ACTIVE_COVERAGE,
  ]);

  return allowedStatuses.has(status);
}
